module.exports = __webpack_public_path__ + "img/topicEnergy.a87e3f66.png";